import { GET_CERTIFICATES } from './../constants';
import { handleActions } from "redux-actions"

export const certificates  = handleActions(
  {
    [ GET_CERTIFICATES ]: (state, action) => action.payload.data
  }, []
)